export default "__VITE_ASSET__b9ca878a__"